"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MintableTokenFactory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "Mint",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "MintFinished",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
        ],
        name: "OwnershipRenounced",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "_owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "_spender",
                type: "address",
            },
        ],
        name: "allowance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_value",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "_owner",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_subtractedValue",
                type: "uint256",
            },
        ],
        name: "decreaseApproval",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [],
        name: "finishMinting",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_addedValue",
                type: "uint256",
            },
        ],
        name: "increaseApproval",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "mint",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "mintingFinished",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_value",
                type: "uint256",
            },
        ],
        name: "transfer",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_from",
                type: "address",
            },
            {
                internalType: "address",
                name: "_to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_value",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "0x6080604052600380546001600160a81b031916331790556109fe806100256000396000f3fe608060405234801561001057600080fd5b50600436106100ba5760003560e01c806305d2035b146100bf578063095ea7b3146100db57806318160ddd1461010757806323b872dd1461012157806340c10f1914610157578063661884631461018357806370a08231146101af578063715018a6146101d55780637d64bcb4146101df5780638da5cb5b146101e7578063a9059cbb1461020b578063d73dd62314610237578063dd62ed3e14610263578063f2fde38b14610291575b600080fd5b6100c76102b7565b604080519115158252519081900360200190f35b6100c7600480360360408110156100f157600080fd5b506001600160a01b0381351690602001356102c7565b61010f61031b565b60408051918252519081900360200190f35b6100c76004803603606081101561013757600080fd5b506001600160a01b03813581169160208101359091169060400135610321565b6100c76004803603604081101561016d57600080fd5b506001600160a01b038135169060200135610482565b6100c76004803603604081101561019957600080fd5b506001600160a01b03813516906020013561057a565b61010f600480360360208110156101c557600080fd5b50356001600160a01b0316610657565b6101dd610672565b005b6100c76106d3565b6101ef610746565b604080516001600160a01b039092168252519081900360200190f35b6100c76004803603604081101561022157600080fd5b506001600160a01b038135169060200135610755565b6100c76004803603604081101561024d57600080fd5b506001600160a01b038135169060200135610820565b61010f6004803603604081101561027957600080fd5b506001600160a01b03813581169160200135166108a7565b6101dd600480360360208110156102a757600080fd5b50356001600160a01b03166108d2565b600354600160a01b900460ff1681565b3360008181526002602090815260408083206001600160a01b038716808552908352818420869055815186815291519394909390926000805160206109aa833981519152928290030190a350600192915050565b60015490565b6001600160a01b03831660009081526020819052604081205482111561034657600080fd5b6001600160a01b038416600090815260026020908152604080832033845290915290205482111561037657600080fd5b6001600160a01b03831661038957600080fd5b6001600160a01b0384166000908152602081905260409020546103b2908363ffffffff6108f516565b6001600160a01b0380861660009081526020819052604080822093909355908516815220546103e7908363ffffffff61090716565b6001600160a01b03808516600090815260208181526040808320949094559187168152600282528281203382529091522054610429908363ffffffff6108f516565b6001600160a01b038086166000818152600260209081526040808320338452825291829020949094558051868152905192871693919260008051602061098a833981519152929181900390910190a35060019392505050565b6003546000906001600160a01b0316331461049c57600080fd5b600354600160a01b900460ff16156104b357600080fd5b6001546104c6908363ffffffff61090716565b6001556001600160a01b0383166000908152602081905260409020546104f2908363ffffffff61090716565b6001600160a01b03841660008181526020818152604091829020939093558051858152905191927f0f6798a560793a54c3bcfe86a93cde1e73087d944c0ea20544137d412139688592918290030190a26040805183815290516001600160a01b0385169160009160008051602061098a8339815191529181900360200190a350600192915050565b3360009081526002602090815260408083206001600160a01b03861684529091528120548083106105ce573360009081526002602090815260408083206001600160a01b0388168452909152812055610603565b6105de818463ffffffff6108f516565b3360009081526002602090815260408083206001600160a01b03891684529091529020555b3360008181526002602090815260408083206001600160a01b0389168085529083529281902054815190815290519293926000805160206109aa833981519152929181900390910190a35060019392505050565b6001600160a01b031660009081526020819052604090205490565b6003546001600160a01b0316331461068957600080fd5b6003546040516001600160a01b03909116907ff8df31144d9c2f0f6b59d69b8b98abd5459d07f2742c4df920b25aae33c6482090600090a2600380546001600160a01b0319169055565b6003546000906001600160a01b031633146106ed57600080fd5b600354600160a01b900460ff161561070457600080fd5b6003805460ff60a01b1916600160a01b1790556040517fae5184fba832cb2b1f702aca6117b8d265eaf03ad33eb133f19dde0f5920fa0890600090a150600190565b6003546001600160a01b031681565b3360009081526020819052604081205482111561077157600080fd5b6001600160a01b03831661078457600080fd5b336000908152602081905260409020546107a4908363ffffffff6108f516565b33600090815260208190526040808220929092556001600160a01b038516815220546107d6908363ffffffff61090716565b6001600160a01b0384166000818152602081815260409182902093909355805185815290519192339260008051602061098a8339815191529281900390910190a350600192915050565b3360009081526002602090815260408083206001600160a01b0386168452909152812054610854908363ffffffff61090716565b3360008181526002602090815260408083206001600160a01b0389168085529083529281902085905580519485525191936000805160206109aa833981519152929081900390910190a350600192915050565b6001600160a01b03918216600090815260026020908152604080832093909416825291909152205490565b6003546001600160a01b031633146108e957600080fd5b6108f28161091a565b50565b60008282111561090157fe5b50900390565b8181018281101561091457fe5b92915050565b6001600160a01b03811661092d57600080fd5b6003546040516001600160a01b038084169216907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e090600090a3600380546001600160a01b0319166001600160a01b039290921691909117905556feddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef8c5be1e5ebec7d5bd14f71427d1e84f3dd0314c0f7b2291e5b200ac8c7c3b925a265627a7a723158201630420b8e79a059e59cfb08548c68b61fba26a7e83c45019110fc467f8cc28764736f6c63430005100032";
class MintableTokenFactory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.MintableTokenFactory = MintableTokenFactory;
MintableTokenFactory.bytecode = _bytecode;
MintableTokenFactory.abi = _abi;
//# sourceMappingURL=MintableTokenFactory.js.map